import low from 'lowdb'
import LocalStorage from 'lowdb/adapters/LocalStorage'

const adapter = new LocalStorage(`d2admin-route-${process.env.VUE_APP_VERSION}`)
// const adapter = new LocalStorage(`d2admin-route`)
// d2admin-route
const db = low(adapter)

db
  .defaults({
    sys: {},
    database: {}
  })
  .write()

export default db